import { CloseCircleOutlined } from "@ant-design/icons";
import { Image, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useMobile } from "../../context/MobileContext";
import { useModal } from "../../context/ModalContext";
import { signInUpEnum } from "../../enumerations/signInUpEnum";
import CustomButton from "../CustomButton";
import CustomPopup from "../CustomPopup";
import { CsFloatButton, SignInForm, SignUpForm } from "./components";
import { useGetLoginCs } from "./hooks/index.hook";
import cs from "./images/cs.png";
import styles from "./style.module.scss";
import "./style.scss";

const SignInUpModal = ({ open, setOpen, onOk }) => {
  const { t } = useTranslation();
  const { mode, setMode } = useModal();
  const { isMobile } = useMobile();

  const { refetch } = useGetLoginCs({ enabled: false });

  const closeModal = () => {
    setOpen(false);
  };

  const handleClickCs = () => {
    refetch().then((res) => {
      window.location.href = res?.data;
    });
  };

  const renderContent = () => {
    return (
      <div className={styles.container}>
        <Image src={"/images/logo.png"} alt="logo" preview={false} className={styles.img} />
        <div className={styles.title}>{modeEnum[mode].title}</div>
        {modeEnum[mode].formComponent}
        <div className={styles.footer} style={{ ...modeEnum[mode].footerStyle }}>
          <div className={styles.left} style={modeEnum[mode].footerLeftStyle}>
            <div className={styles.text}>{modeEnum[mode].footerHint}</div>
            <CustomButton
              buttonStyle={`${styles.footerCustomButtonStyle}`}
              type={"text"}
              onClick={() => setMode(modeEnum[mode].footerButtonGoto)}
            >
              {modeEnum[mode].footerButtonText}
            </CustomButton>
          </div>
          {modeEnum[mode].showCs ? (
            isMobile ? (
              <CsFloatButton onClick={handleClickCs} />
            ) : (
              <div className={styles.right} onClick={handleClickCs}>
                <Image src={cs} alt="cs" preview={false} width={38} />
              </div>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  };

  const modeEnum = {
    [signInUpEnum.SIGN_IN]: {
      width: 374,
      title: t("normal.signIn"),
      submitButtonText: t("nav.signIn"),
      footerHint: t("signInUpModal.haveAccount"),
      footerButtonText: t("nav.signUp"),
      footerButtonGoto: signInUpEnum.SIGN_UP,
      footerStyle: { justifyContent: "space-between" },
      footerLeftStyle: {
        flexDirection: isMobile ? "row" : "column",
        alignItems: isMobile ? "center" : "flex-start",
      },
      formComponent: <SignInForm closeModal={closeModal} />,
      showCs: true,
    },
    [signInUpEnum.SIGN_UP]: {
      width: 688,
      title: t("normal.signUp"),
      submitButtonText: t("nav.signUp"),
      footerHint: t("signInUpModal.alreadyRegister"),
      footerButtonText: t("nav.signIn"),
      footerButtonGoto: signInUpEnum.SIGN_IN,
      footerStyle: { justifyContent: "center" },
      footerLeftStyle: { flexDirection: "row", alignItems: "center" },
      formComponent: <SignUpForm closeModal={closeModal} />,
      showCs: false,
    },
  };

  return isMobile ? (
    <CustomPopup
      visible={open}
      onClose={() => setOpen(false)}
      destroyOnClose={true}
      title={modeEnum[mode].title}
      className={`${styles.signInUpModal} sign-in-up-popup`}
    >
      {renderContent()}
    </CustomPopup>
  ) : (
    <Modal
      title={null}
      open={open}
      onOk={onOk}
      width={modeEnum[mode].width}
      onCancel={() => setOpen(false)}
      closeIcon={<CloseCircleOutlined className={styles.close} />}
      wrapClassName={`${styles.signInUpModal} sign-in-up-modal`}
      destroyOnClose={true}
      footer={null}
    >
      {renderContent()}
    </Modal>
  );
};

export default SignInUpModal;
